var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramEftpos40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.30666667,-3.99680289e-15 L12.6933333,-3.99680289e-15 C13.4149854,-3.99680289e-15 14,0.564121215 14,1.26 L14,7.74 C14,8.43587876 13.4149854,9 12.6933333,9 L1.30666667,9 C0.585014593,9 0,8.43587876 0,7.74 L0,1.26 C0,0.564121215 0.585014593,-3.99680289e-15 1.30666667,-3.99680289e-15 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EFTPOS40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "#FFFFFF",
    points: "13.9255638 8.25336075 11.7757454 10.3331089 11.7757454 30.9969406 12.8506546 32.1556168 15.4426613 32.1556168 16.4899101 30.9969406 21.6698875 30.9969406 22.7669945 32.1556168 25.7006721 32.1556168 26.5608025 30.9969406 26.5608025 22.9255066 24.6064301 22.9255066 21.9935532 22.9255066 21.9935532 13.5855713 26.5608025 13.5855713 26.5608025 7.91160107"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.000000, 7.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5,0.5 L2.5,0.5 M2.5,0.5 L0.5,2.5 M0.5,2.52380952 L0.5,23.4761905 M15.5,0.5 L15.5,5.5 M15.5,15.5 L15.5,23.5 M1.5,24.5 L4.5,24.5 M0.5,23.5 L1.5,24.5 M11.5,24.5 L14.5,24.5 M5.5,23.5 L10.5,23.5 M14.5,24.5 L15.5,23.5 M10.5,23.5 L11.5,24.5 M5.5,23.5 L4.5,24.5",
    id: "Combined-Shape",
    stroke: "#4F4C4D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram/cards",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.30666667,-3.99680289e-15 L12.6933333,-3.99680289e-15 C13.4149854,-3.99680289e-15 14,0.564121215 14,1.26 L14,7.74 C14,8.43587876 13.4149854,9 12.6933333,9 L1.30666667,9 C0.585014593,9 0,8.43587876 0,7.74 L0,1.26 C0,0.564121215 0.585014593,-3.99680289e-15 1.30666667,-3.99680289e-15 Z",
    id: "path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "brand-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "brand",
    stroke: "#4F4C4D",
    fill: "#FFCC00",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "11.7882381 0.28125 7.41248305 4.53835489 11.7867145 8.71875 17.0008219 8.71875 17.0008219 0.28125"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.05913043,0 C0.47418885,0 0,0.467414724 0,1.044 L0,7.956 C0,8.5325853 0.47418885,9 1.05913043,9 L12.9408696,9 C13.5258112,9 14,8.5325853 14,7.956 L14,1.044 C14,0.467414724 13.5258112,0 12.9408696,0 L1.05913043,0 Z",
    id: "Path",
    stroke: "#4F4C4D"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramEftpos40);
export default __webpack_public_path__ + "static/media/pictogramEFTPOS40.116afb70db50c27ac105fc1d34b30f53.svg";
export { ForwardRef as ReactComponent };